












import { defineComponent } from '@nuxtjs/composition-api';
import { BaseImage, BaseLink } from '@shared/ui';
import { getStoryblokImageURL } from '@unified-commerce/gpc-vue-storefront-storyblok';

export default defineComponent({
  name: 'PromotionCard',
  components: {
    BaseImage,
    BaseLink,
  },
  props: {
    promotion: {
      type: Object,
      required: true,
    },
  },
  computed: {
    promoLink(): string {
      return this.promotion?.content?.url || '';
    },
    promoImageSrc(): string {
      return getStoryblokImageURL(this.promotion?.content?.image?.filename);
    },
    promoImageAlt(): string {
      return this.promotion?.content?.image?.alt;
    },
  },
});
